import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  errorMessages: {
    color: "#F36F6F",
    fontSize: 13,
    marginTop: 5,
    display: "flex",
    alignItems: 'center',
    lineHeight: '15px',
    "& img": {
      width: 18,
      minWidth: 18,
      marginRight: 4,
    }
  }
}));

export default useStyles;
